<div class="carousel-container" [ngClass]="[slides.length > 1 ? 'carousel-container-width':'',fromFirstGuide?'guide-carousel-container':'']">
    <div id="demo" class="carousel slide" data-interval="false" data-ride="carousel" data-pause="hover">
        <div class="row">
            <div class="col-12">
                <div class="carousel-inner carousel-height">
                    <div class="carousel-item" *ngFor="let slide of slides; let i=index" [class.active]="i==activeSlide">
                        <div>
                            <img alt="Image" [hidden]="fromFirstGuide" class="carousel-image" [ngClass]="{'carousel-gif-file' : isGifFile(slide)}" (click)="isGifFile(slide) ? '' : openDialog(i);"
                                *ngIf="!isVideo(slide)" [src]="slide" (load)="onImageLoad($event)">
                            <img alt="Image" [hidden]="!fromFirstGuide" class="carousel-image" [ngClass]="{'guide-carousel-image':fromFirstGuide}" (click)="openDialog(i);"
                                *ngIf="!isVideo(slide)" [src]="slide" (load)="onImageLoad($event)">
                        </div>

                        <video *ngIf="isVideo(slide)" controls preload='metadata' class="carousel-video">
                            <source [src]="imagePath+slide" type='video/mp4' />
                            <source [src]="imagePath+slide" type='video/ogg' />
                        </video>

                        <div class="zoom-in-icon-container" [ngClass]="[isGifFile(slide) ? 'gif-file-container' :'',fromFirstGuide ? 'guide-zoom-in-container':'']"
                            (click)="isGifFile(slide) ? '' : openDialog(i);" *ngIf="(!isVideo(slide) && (!isGifFile(slide)))">
                            <em class="fa fa-search-plus"></em>
                        </div>

                        <div (click)="isGifFile(slide) ? '' : openDialog(i);" *ngIf="(!fromFirstGuide && (windowWidth > 550) && (!isVideo(slide) && (!isGifFile(slide))))"
                            style="cursor: zoom-in;position: relative;padding-top: 3px;">
                            <span class="carousel-zoom-text-{{appName}}" *ngIf="windowWidth > 768" [ngClass]="{'guide-zoom-in-text':fromFirstGuide}">Click or Tap to zoom</span>
                        </div>
                    </div>
                </div>

                <ul class="carousel-indicators" *ngIf="slides.length > 1">
                    <li *ngFor="let slide of slides; let i=index" (click)="switchSlide(i)" data-target="#demo" [attr.data-slide-to]="i" [class.active]="i==activeSlide">
                        <div class="image-thumbnail thumbnail" *ngIf="!isVideo(slide)">
                            <img [alt]="imagePath+slide" [src]="imagePath+slide" (load)="onImageLoad($event)" />
                        </div>
                        <video class="video-thumbnail thumbnail" *ngIf="isVideo(slide)">
                            <source [src]="imagePath+slide+'#t=0'" type="video/mp4" />
                        </video>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>